/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { IInspectorControl_ButtonGroup, TInspectorControlProps } from "../InspectorControlTypes";
import { FieldGroup } from "@adapptio/lib-editor-ui";
import { useBlueprintModel } from "../../../ui/hooks/useBlueprintModel";
import { InspectorControlButtonGroup_Button } from "./InspectorControlButtonGroup_Button";
import { isSchemaConstBooleanModel, isSchemaValueModel } from "@adapptio/lib-blueprint";

export interface IInspectorControlButtonGroupProps
	extends TInspectorControlProps<IInspectorControl_ButtonGroup> {}

export const InspectorControlButtonGroup: React.FC<IInspectorControlButtonGroupProps> = ({
	model: _model
}) => {
	const { model } = useBlueprintModel(_model, "constObject");

	return (
		<FieldGroup grow preventTruncate>
			{Object.keys(model.props).map((propKey) => {
				const propModel = model.props[propKey];
				const btnModel = isSchemaValueModel(propModel) ? propModel.constant : propModel;

				if (!isSchemaConstBooleanModel(btnModel)) {
					return null;
				}

				return <InspectorControlButtonGroup_Button key={btnModel.nodeId} model={btnModel} />;
			})}
		</FieldGroup>
	);
};
